/**
 *
 * RequestAccessPage
 *
 */

import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import appConfig from 'appConfig';
import { Button, Card, H2, Input } from '@pearsontechnology/aero-components';
import { Wrapper, Form, InputWrapper, ActionsWrapper, SuccessfullySubmittedWrapper, ErrorMessageWrapper } from './styles';
import messages from './messages';
import { dispatch } from 'pluginServices/store';
import { pushToast } from 'containers/ToastManager/actions';

function RequestAccessPage({ requestStatus }) {
  const [workspace, setWorkspace] = useState('');
  const [manager, setManager] = useState('');
  const [reason, setReason] = useState('');
  const [workspaceFeedback, setWorkspaceFeedback] = useState('');
  const [managerFeedback, setManagerFeedback] = useState('');
  const [reasonFeedback, setReasonFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successfullySubmitted, setSuccessfullySubmitted] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  
  const onChange = (field) => (event) => {
    const newValue = event.target.value;
    const setters = {
      workspace: [setWorkspace, setWorkspaceFeedback, messages.workspaceEmptyFeedback],
      manager: [setManager, setManagerFeedback, messages.managerEmptyFeedback],
      reason: [setReason, setReasonFeedback, messages.reasonEmptyFeedback],
    };
    const [setValue, setFeedback, emptyMessage] = setters[field];
    setValue(newValue);
    setFeedback(newValue.trim() ? '' : intl.formatMessage(emptyMessage));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const newWorkspaceFeedback = workspace.trim() ? '' : intl.formatMessage(messages.workspaceEmptyFeedback);
    const newManagerFeedback = manager.trim() ? '' : intl.formatMessage(messages.managerEmptyFeedback);
    const newReasonFeedback = reason.trim() ? '' : intl.formatMessage(messages.reasonEmptyFeedback);

    setWorkspaceFeedback(newWorkspaceFeedback);
    setManagerFeedback(newManagerFeedback);
    setReasonFeedback(newReasonFeedback);

    if (newWorkspaceFeedback || newManagerFeedback || newReasonFeedback) {
      return;
    }
    saveRequestAccess();
  };

  const saveRequestAccess = async () => {
    setSubmitError(false);
    setIsSubmitting(true);
    try {
      const response = await fetch(appConfig.getRequestAccessURL(), {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({ pearsonId: requestStatus.pearsonId, region: requestStatus.region, workspace: workspace.trim(), manager: manager.trim(), reason: reason.trim() }),
      });
      const data = await response.json();
      if (response?.status !== 201) {
        dispatch(pushToast({ message: `${intl.formatMessage(messages.submitError)} - ${data?.message}` }));
        setSuccessfullySubmitted(false);
        setSubmitError(true);
      } else {
        setSuccessfullySubmitted(true);
      }
    } catch (error) {
      setSuccessfullySubmitted(false);
      setSubmitError(true);
    }
    setIsSubmitting(false);
  };

  const isFormValid = workspace.trim() && manager.trim() && reason.trim();
  return (
    <Wrapper>
      <Form onSubmit={handleSubmit}>
        <Card>
          {successfullySubmitted ? (
            <SuccessfullySubmittedWrapper>
              <FormattedMessage {...messages.successfullySubmitted} />
            </SuccessfullySubmittedWrapper>
          ) : submitError ? (
            <ErrorMessageWrapper>
              <FormattedMessage {...messages.submitError} />
            </ErrorMessageWrapper>
          ) : (
            <>
              <H2><FormattedMessage {...messages.title} /></H2>
              <InputWrapper>
                <Input
                  type="text"
                  value={workspace}
                  feedback={workspaceFeedback}
                  label={intl.formatMessage(messages.workspace)}
                  onChange={onChange('workspace')}
                />
                <Input
                  type="text"
                  value={manager}
                  feedback={managerFeedback}
                  label={intl.formatMessage(messages.manager)}
                  onChange={onChange('manager')}
                />
                <Input
                  type="text"
                  value={reason}
                  feedback={reasonFeedback}
                  label={intl.formatMessage(messages.reason)}
                  onChange={onChange('reason')}
                />
              </InputWrapper>
              <ActionsWrapper>
                <Button type="submit" primary disabled={!isFormValid || isSubmitting} isLoading={isSubmitting} loadable>
                  <FormattedMessage {...messages.submit} />
                </Button>
              </ActionsWrapper>
            </>
          )}
        </Card>
      </Form>
    </Wrapper>
  );
}

export default RequestAccessPage;
